// ETNRLZ — global theme script

// Product form: update hidden variant id when option selects change
document.addEventListener('change', e => {
  const sel = e.target.closest('form.shopify-product-form select[name^="options["]');
  if (!sel) return;
  const form = sel.closest('form.shopify-product-form');
  const dataEl = form.querySelector('script[data-product-variants]');
  const idInput = form.querySelector('input[data-variant-id]');
  const addBtn = form.querySelector('button[type="submit"]');
  if (!dataEl || !idInput) return;
  let variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
  const selects = Array.from(form.querySelectorAll('select[name^="options["]'));
  const chosen = selects.map(s => s.value);
  const match = variants.find(v => v.options.every((opt, i) => opt === chosen[i]));
  if (match) {
    idInput.value = match.id;
    if (addBtn) {
      if (match.available) {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to cart →';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = 'Sold out';
      }
    }
  }
});

// Collection filters (client-side highlight)
document.addEventListener('click', e => {
  const btn = e.target.closest('[data-filter]');
  if (!btn) return;
  document.querySelectorAll('[data-filter]').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
});

// Quick-add to cart (AJAX)
document.addEventListener('click', async e => {
  const btn = e.target.closest('[data-quick-add]');
  if (!btn) return;
  e.preventDefault();
  const id = btn.dataset.quickAdd;
  const original = btn.textContent;
  btn.textContent = 'Adding...';
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id, quantity: 1 })
    });
    if (!res.ok) throw new Error('add failed');
    btn.textContent = 'Added ✓';
    btn.style.borderColor = 'var(--accent)';
    btn.style.color = 'var(--accent)';
    const cart = await (await fetch('/cart.js')).json();
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = '[' + String(cart.item_count).padStart(2, '0') + ']';
    });
  } catch (err) {
    btn.textContent = 'Error';
  }
  setTimeout(() => {
    btn.textContent = original;
    btn.style.borderColor = '';
    btn.style.color = '';
  }, 1600);
});
